import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import TipBox from "components/InfoBox";
import { fetchTips } from "./actions";

const mapStateToProps = (state) => ({
  selectedCategory: state.tips.selectedCategory,
  selectedCountry: state.tips.selectedCountry,
  isFetching: state.tips.isFetching,
  statistics: state.tips.statistics,
});

const Tips = (props) => {
  const {
    selectedCategory,
    selectedCountry,
    statistics,
    isFetching,
    dispatch,
  } = props;
  useEffect(() => {
    dispatch(fetchTips(selectedCategory, selectedCountry));
  }, [selectedCountry, selectedCategory, dispatch]);

  return (
    <TipBox isLoading={isFetching}>
      <p>
        The best
        {" "}
        {selectedCategory}
        {" "}
        campaigns
        {" "}
        {" "}
        {selectedCountry ? (
          <span>
            in
            {" "}
            {selectedCountry}
            {" "}
            {" "}
          </span>
        ) : null}
        are raising:
        {" "}
        <br />
        {statistics.currency_symbol || "$"}
        <i>
          {statistics.amount_raised}
          {" "}
        </i>
        {statistics.currency || "AUD"}
      </p>
      <p>
        Over
        {" "}
        <i>{statistics.campaigns_count}</i>
        {" "}
        campaigns
        {" "}
        {" "}
        {selectedCountry ? (
          <span>
            in
            {" "}
            {selectedCountry}
            {" "}
            {" "}
          </span>
        ) : null}
        have crowdfunded on Chuffed.org
      </p>
    </TipBox>
  );
};

Tips.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  selectedCategory: PropTypes.string.isRequired,
  selectedCountry: PropTypes.string.isRequired,
  statistics: PropTypes.object.isRequired,
};

const TipsContainer = connect(
  mapStateToProps,
)(Tips);

export default TipsContainer;
